import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import EverythingMenu from '../EverythingMenu';
import { MenuButtons as DeviationMenu } from '../../../extensions/extension-deviation/components/DaDeviationBubbleMenu/DaDeviationBubbleMenu';
import { MenuButtons as GalleryMenu } from '../../../extensions/extension-gallery/components/DaGalleryBubbleMenu/DaGalleryBubbleMenu';
import { MenuButtons as GifMenu } from '../../../extensions/extension-gif/components/DaGifBubbleMenu/DaGifBubbleMenu';
import { MenuButtons as VideoMenu } from '../../../extensions/extension-video/components/DaVideoBubbleMenu/DaVideoBubbleMenu';
import { MenuButtons as DeviationThumbMenu } from '../../../extensions/extension-deviation-thumb/components/DaDeviationThumbBubbleMenu/DaDeviationThumbBubbleMenu';
import s from './UniversalMobileMenu.scss';
export var MenuState = /*#__PURE__*/ function(MenuState) {
    MenuState[MenuState["FORMAT"] = 0] = "FORMAT";
    return MenuState;
}({});
const UniversalMobileMenu = (props)=>{
    const editor = useEditorContext();
    const forceUpdate = useForceUpdate();
    // Listen to editor as its not react so we need to react here
    editor === null || editor === void 0 ? void 0 : editor.on('transaction', ()=>{
        forceUpdate();
    });
    if (!editor) {
        return null;
    }
    // Deviation plugin menu states
    if (editor.storage['da-deviation'].menuState === 1) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['plugin-menu-root']
        }, /*#__PURE__*/ React.createElement(DeviationMenu, {
            editor: editor,
            forMobile: true
        }));
    }
    // Gallery plugin menu states
    if (editor.storage['da-gallery'].menuState === 1) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['plugin-menu-root']
        }, /*#__PURE__*/ React.createElement(GalleryMenu, {
            editor: editor,
            forMobile: true
        }));
    }
    // Gif plugin menu states
    if (editor.storage['da-gif'].menuState === 1) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['plugin-menu-root']
        }, /*#__PURE__*/ React.createElement(GifMenu, {
            editor: editor,
            forMobile: true
        }));
    }
    // Video plugin menu states
    if (editor.storage['da-video'].menuState === 1) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['plugin-menu-root']
        }, /*#__PURE__*/ React.createElement(VideoMenu, {
            editor: editor,
            forMobile: true
        }));
    }
    // Deviation thumb plugin menu states
    if (editor.storage['da-deviation-thumb'].menuState === 1) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['plugin-menu-root']
        }, /*#__PURE__*/ React.createElement(DeviationThumbMenu, {
            editor: editor,
            forMobile: true
        }));
    }
    // Main formatting menu states
    const menuState = 0;
    let menu;
    switch(menuState){
        case 0:
        default:
            menu = /*#__PURE__*/ React.createElement(EverythingMenu, {
                wrapping: false,
                noAtomics: props.noAtomics,
                omitHRule: props.omitHRule
            });
            break;
    }
    return /*#__PURE__*/ React.createElement("div", null, menu);
};
UniversalMobileMenu.displayName = 'UniversalMobileMenu';
export default UniversalMobileMenu;

//# sourceMappingURL=UniversalMobileMenu.js.map